import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import SecondaryNavBar from "./components/SecondaryNavBar"
import { Header } from "./components/header";
import { SobreNosotros } from "./components/SobreNosotros";
import { BrandSwiper } from "./components/BrandSwiper";
import { Servicios } from "./components/servicios";
import { Contacto } from "./components/contacto";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import {InstagramEmbedCustom} from "./components/instagramEmbedCustom";
import InstagramFeed from './components/InstagramFeed';
import "./App.css";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <SecondaryNavBar />
      <Servicios data={[landingPageData.ServiciosBasico, landingPageData.ServiciosEspecializado]} />
      <SobreNosotros data={landingPageData.SobreNosotros} />
      <BrandSwiper data={landingPageData.Brands} />
      {/* <InstagramFeed data={landingPageData.Access} /> */}
      <InstagramEmbedCustom data={landingPageData.Access} />
      <Contacto data={landingPageData.Contacto} />

    </div>
  );
};

export default App;
